import { Dropdown, Modal } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import CachedIcon from "mdi-react/CachedIcon";
import { useQuery } from "react-query";
import { format } from "date-fns";
import ReactPaginate from "react-paginate";
import DotsHorizontalIcon from "mdi-react/DotsHorizontalIcon";
import queryString from "query-string";
import moment from "moment";
import Select from "react-select";

import useDebounce, {
  useLocalStorage,
  useQueryParams,
  useScrollTop,
} from "../../utils/hooks";
import {
  ExportIcon,
  FilterTwoIcon,
  NoSelectedItemIcon,
  ExcelIcon,
  ViewIcon,
} from "../Icons";
import "../../assets/scss/reports/cashbook.scss";
import { paginationOptions } from "../../utils/helpers";
import { useAuth } from "../../hooks/useAuth";
import { fetchActionsUtil } from "../../utils/helpers";
import TableComponent from "../TableComponent";
import ModalLoader from "../utils/ModalLoader";
import { useDownloadExcel } from "../../hooks/useDownloadExcel";
import { CSVLink } from "react-csv";
import currency from "currency.js";

const allStatus = [
  "All",
  "Rejected",
  "Partly Received",
  "Received All",
  "Retured",
  null,
];

const JobWareHouseIssuedItems = ({
  warehouseLocal,
  onHide,
  show,
  Trans_ID,
  contracts,
  jobName,
}) => {
  useScrollTop();
  const initialFilterParams = {
    Trans_ID: "",
    serialNumbers: "",
    contracts: "",
    Requester: "",
  };

  const { backendUrl } = useAuth();
  const [showFilter, setShowFilter] = useLocalStorage("showFilter", false);
  const [allIsuesItems, setAllIsuesItems] = useState([]);
  const [showStatus, setShowStatus] = useState("All");
  const [isLoadingVendors, setIsLoadingVendors] = useState(false);
  const [excelData, setExcelData] = useState([]);

  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });

  const CSVLinkRef = useRef(null);

  // fetch excel hook
  const [isfetchingExcel, fetchExcelData] = useDownloadExcel(
    excelData,
    CSVLinkRef
  );

  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });

  const debouncedFilterParams = useDebounce(filterParams, 500);

  useEffect(() => {
    setQueryParams((query) => ({ ...query, ...debouncedFilterParams }));
  }, [debouncedFilterParams, setQueryParams]);

  const fetchSetUpData = async (queryParams, ware, Trans_ID) => {
    setIsLoadingVendors(true);

    let response = await fetchActionsUtil(
      `${backendUrl}/api/warehouse/issuer-setup/${ware}?&${queryString.stringify(
        { ...queryParams, Trans_ID, contracts }
      )}`,
      "GET"
    );

    const warehousesData = await fetchActionsUtil(
      `${backendUrl}/api/warehouse/categories/${warehouseLocal?.cater}`,
      "GET"
    );

    const jobs = await fetchActionsUtil(`${backendUrl}/api/job`, "GET");

    const plantsData = await fetchActionsUtil(
      `${backendUrl}/api/production/plants`,
      "GET"
    );

    const { data } = response;

    setAllIsuesItems(() => data.issuedItems);

    data.jobs = jobs?.data?.jobs?.map((el) => ({
      value: el.jobNumber,
      label: el.title,
    }));

    data.inJobs = [{ label: "None", value: "" }, ...data?.jobs];

    data.staff = data.staffs.map((el) => ({
      value: el.Name,
      label: el.Name,
    }));

    data.userRequesters = data.userRequesters.map((el) => ({
      value: el.name,
      label: el.name,
    }));

    // Merge staff and userRequesters, then make unique by 'value'
    const mergedRequesters = [...data.staff, ...data.userRequesters];
    const uniqueRequestersMap = new Map();
    mergedRequesters.forEach((req) => {
      uniqueRequestersMap.set(req.value, req);
    });
    data.userRequesters = Array.from(uniqueRequestersMap.values());

    data.changedstaff = data.staffs.map((el) => ({
      value: `${el.Name}-${el.email}`,
      label: el.Name,
    }));

    data.employees = data.employees.map((el) => ({
      value: el.EmployeeID,
      label: `${el.FirstName} ${el.LastName}`,
    }));

    data.locationsMap = [
      {
        value: "",
        label: "All",
      },
      ...data.Alllocation.map((el) => ({
        value: el.locationID,
        label: el.name,
      })),
    ];

    data.locations = data.Alllocation.map((el) => ({
      value: el.locationID,
      label: el.name,
    }));

    data.warehouses = warehousesData?.warehouses
      ?.filter((e) => e.W_ID !== warehouseLocal?.whID)
      ?.map((el) => ({
        value: el.W_ID,
        label: el.W_name,
      }));

    data.requesters = [
      {
        value: "",
        label: "All",
      },
      ...data.AllWarehouse.map((el) => ({
        value: el?.W_ID,
        label: el?.W_name,
      })),
    ];

    data.plants = plantsData.allPlants.map((el) => ({
      value: `${el[0].Plant_ID}-plant`,
      label: el[0].Plant_Name,
    }));
    setIsLoadingVendors(false);
    return data;
  };

  const {
    data = {
      countItemsIssueLog: 0,
      staff: [],
      requesters: [],
      warehouseActive: {},
    },
    refetch,
    isLoading,
  } = useQuery(
    ["WAREHOUSE_ISSUE_ITEMS", { queryParams, warehouseLocal, Trans_ID }],
    () => fetchSetUpData(queryParams, warehouseLocal?.whID, Trans_ID),
    {
      keepPreviousData: false,
      staleTime: 0,
    }
  );

  const onStatusSelect = (value) => {
    setShowStatus(value);
    console.log(value);

    const filter =
      value !== "Pending"
        ? data?.issuedItems.filter((d) => d.Status === value)
        : data?.issuedItems.filter((d) => d.Status === null);

    if (value === "All") {
      setAllIsuesItems(() => data.issuedItems);
    } else {
      setAllIsuesItems(() => filter);
    }
  };

  const handleSearchQueryChange = (e) => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  const checkQtyStatus = ({ Status, Qty, qtyReceiver }) => {
    let reQty = qtyReceiver;
    if (Status === "Retured" || Status === "Rejected") {
      reQty = Qty - qtyReceiver;
    } else if (Status === "Partly Received") {
      reQty = qtyReceiver;
    }

    return reQty;
  };

  const displayTableData = (el, index) => {
    return (
      <>
        <td>
          <Dropdown style={{ margin: 0 }} alignRight drop="end">
            <Dropdown.Toggle
              variant=""
              className="bg-white border border-white"
              bsPrefix="print more"
            >
              <DotsHorizontalIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu
              popperConfig={{
                strategy: "fixed",
              }}
              renderOnMount
              className="dropdown-with-icons"
            >
              <Dropdown.Item
                as="a"
                href={`${backendUrl}/api/warehouse/pdf/waybill-invoice/${
                  el?.Trans_ID
                }`}
                target="_blank"
              >
                <ViewIcon /> View Invoice
              </Dropdown.Item>
              <Dropdown.Item
                as="a"
                href={`${backendUrl}/api/warehouse/pdf/waybill-invoice/${
                  el?.Trans_ID
                }?waybill=${true}`}
                target="_blank"
              >
                <ViewIcon /> View Waybill
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </td>
        <td>{el?.Bar_Code}</td>
        <td>
          {warehouseLocal?.cater === "Assets"
            ? el?.Serial_Number
            : JSON.parse(el?.serialNumbers)?.map((sl) => (
                <span className="mx-2">{sl?.serialNum}</span>
              ))}
        </td>
        <td>{el?.Item_Name}</td>
        <td>
          {currency(el?.UnitCost, {
            symbol: "",
          }).format()}
        </td>
        <td className="text-center">{el?.Quantity}</td>
        <td>
          {currency(el?.UnitCost, {
            symbol: "",
          })
            .multiply(el?.Quantity)
            .format()}
        </td>
        <td className="text-nowrap">
          {el?.WH_Issues_details?.W_name
            ? el?.WH_Issues_details?.W_name
            : el?.Plant_Issues_details?.Plant_Name
            ? el?.Plant_Issues_details?.Plant_Name
            : "Sales"}
          <span className="px-2">- {el?.RequesterName}</span>
        </td>
        <td className="text-center">
          {checkQtyStatus({
            Status: el?.Status,
            Qty: el?.Quantity,
            qtyReceiver: el?.QuantityFromReciever,
          })}
        </td>
        <td>
          {`${format(new Date(el?.Date_Log), "yyyy-MM-dd")} ${
            el?.IssueTime?.includes("Z")
              ? format(new Date(el.IssueTime), "HH:mm:ss a")
              : el?.IssueTime
          }`}
        </td>
        <td>
          <div
            className={`px-2 ${
              el.Status === "Rejected"
                ? "view_status_reject"
                : el.Status === "Partly Received"
                ? "view_status_partly"
                : el.Status === "Received All"
                ? "view_status_all"
                : el.Status === "Retured"
                ? "view_status_returned"
                : el.Status === null
                ? "view_status_pending"
                : ""
            }`}
          >
            {el.Status !== null ? el.Status : "Pending"}
          </div>
        </td>
        <td>{el?.Comment}</td>
      </>
    );
  };

  const tableHead = () => {
    return (
      <thead>
        <tr>
          <th />
          <th>Bar Code</th>
          <th>Serial Number</th>
          <th>Item Name</th>
          <th>UnitCost</th>
          <th>Qty Issued</th>
          <th>Total</th>
          <th>Receiver</th>
          <th>Qty Received </th>
          <th>Date</th>
          <th>Status</th>
          <th>Comment</th>
        </tr>
      </thead>
    );
  };

  const tableStorageHead = () => {
    return (
      <thead>
        <tr>
          <th />
          <th>Bar Code</th>
          <th>Serial Number</th>
          <th>Item Name</th>
          <th>UnitCost</th>
          <th>Qty Issued</th>
          <th>Total</th>
          <th className="text-center">Receiver</th>
          <th className="text-center">Comment</th>
          <th>Contract</th>
          <th>Returned</th>
          <th className="text-center">Date</th>
          <th className="text-center">Duration in possession</th>
          <th>Status</th>
        </tr>
      </thead>
    );
  };

  const displayStorageTableData = (el, index) => {
    const given = moment(
      format(new Date(el?.Date_Log), "yyyy-MM-dd"),
      "YYYY-MM-DD"
    );
    const current = moment().startOf("day");

    //Difference in number of days
    const duration = moment.duration(given.diff(current)).asDays();

    return (
      <>
        <td>
          <Dropdown style={{ margin: 0 }} alignRight drop="end">
            <Dropdown.Toggle
              variant=""
              className="bg-white border border-white"
              bsPrefix="print more"
            >
              <DotsHorizontalIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu
              popperConfig={{
                strategy: "fixed",
              }}
              renderOnMount
              className="dropdown-with-icons"
            >
              <Dropdown.Item
                as="a"
                href={`${backendUrl}/api/warehouse/pdf/waybill-invoice/${
                  el?.Trans_ID
                }`}
                target="_blank"
              >
                <ViewIcon /> View Invoice
              </Dropdown.Item>
              <Dropdown.Item
                as="a"
                href={`${backendUrl}/api/warehouse/pdf/waybill-invoice/${
                  el?.Trans_ID
                }?waybill=${true}`}
                target="_blank"
              >
                <ViewIcon /> View Waybill
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </td>
        <td>{el?.Bar_Code}</td>
        <td>{el?.Serial_Number}</td>
        <td>{el?.Item_Name}</td>
        <td>
          {currency(el?.UnitCost, {
            symbol: "",
          }).format()}
        </td>
        <td className="text-center">{el?.Quantity}</td>
        <td>
          {currency(el?.UnitCost, {
            symbol: "",
          })
            .multiply(el?.Quantity)
            .format()}
        </td>
        <td className="text-nowrap">
          {el?.WH_Issues_location?.name}
          <span className="px-2">- {el?.RequesterName}</span>
        </td>
        <td>{el?.Comment}</td>
        <td>{el?.jobs_Issuer?.title}</td>
        <td>{el?.QuantityFromReciever}</td>
        <td>
          {`${format(new Date(el?.Date_Log), "yyyy-MM-dd")} ${
            el?.IssueTime?.includes("Z")
              ? format(new Date(el.IssueTime), "HH:mm:ss a")
              : el?.IssueTime
          }`}
        </td>
        <td className="text-center">
          {duration < 0
            ? `${Math.abs(duration)} day(s) ago`
            : duration === 0
            ? `${duration} day`
            : `${duration} day(s) ahead`}
        </td>
        <td>
          <div
            className={`px-2 ${
              el.Status === "Rejected"
                ? "view_status_reject"
                : el.Status === "Received"
                ? "view_status_partly"
                : el.Status === "Retured"
                ? "view_status_all"
                : el.Status === "Partly Retured"
                ? "view_status_returned"
                : el.Status === null
                ? "view_status_pending"
                : ""
            }`}
          >
            {el.Status !== null ? el.Status : "Issued"}
          </div>
        </td>
      </>
    );
  };

  const DataBody = (exData) => {
    let body = [];

    const given = moment(new Date(exData[0]?.Date_Log), "YYYY-MM-DD");
    const current = moment().startOf("day");

    //Difference in number of days
    const duration = moment.duration(given.diff(current)).asDays();

    if (data?.warehouseActive?.Warehouse_Type !== "Storage") {
      body = exData.map((d) => [
        d.Bar_Code,
        warehouseLocal?.cater === "Assets"
          ? d?.Serial_Number
          : JSON.parse(d?.serialNumbers)?.map((sl) => `${sl?.serialNum}, `),
        d.Item_Name,
        d?.UnitCost,
        d.Quantity,
        currency(d?.UnitCost, {
          symbol: "",
        })
          .multiply(d?.Quantity)
          .format(),
        `${
          d?.WH_Issues_details?.W_name
            ? d?.WH_Issues_details?.W_name
            : d?.Plant_Issues_details?.Plant_Name
            ? d?.Plant_Issues_details?.Plant_Name
            : "Sales"
        } - ${d?.RequesterName}`,
        d?.QuantityFromReciever,
        `${d.Date_Log} ${d.IssueTime}`,
        d.Status !== null ? d.Status : "Pending",
        d.Comment,
      ]);
    } else {
      body = exData.map((d) => [
        d.Bar_Code,
        d?.Serial_Number,
        d.Item_Name,
        d?.UnitCost,
        d.Quantity,
        currency(d?.UnitCost, {
          symbol: "",
        })
          .multiply(d?.Quantity)
          .format(),
        `${d?.WH_Issues_location?.name} - ${d?.RequesterName}`,
        d?.Comment,
        d?.el?.jobs_Issuer?.title,
        d?.QuantityFromReciever,
        `${d.Date_Log} ${d.IssueTime}`,
        duration < 0
          ? `${Math.abs(duration)} day(s) ago`
          : duration === 0
          ? `${duration} day`
          : `${duration} day(s) ahead`,
        d.Status !== null ? d.Status : "Issued",
      ]);
    }

    return body;
  };

  const { limit, page, ...rest } = queryParams;
  const onDownloadExcelData = async () => {
    let exData = await fetchExcelData(
      `${backendUrl}/api/warehouse/issuer-setup/${
        warehouseLocal?.whID
      }?&${queryString.stringify({ ...rest, Trans_ID })}`,
      "GET"
    );

    const company = exData.data?.company?.CompName;

    exData = exData.data.issuedItems.map((row) => ({
      ...row,
      Date_Log: format(new Date(row.Date_Log), "dd-MMM-yyyy"),
      IssueTime: row?.IssueTime?.includes("Z")
        ? format(new Date(row.IssueTime), "HH:mm:ss a")
        : row?.IssueTime,
    }));

    const total = currency(
      exData.reduce((a, b) => a + b.UnitCost * b.Quantity, 0),
      {
        symbol: "",
      }
    ).format();

    exData = DataBody(exData);
    const date =
      rest.startDate && rest.endDate
        ? `Date Prepared: Between ${format(
            new Date(rest.startDate),
            "E MMM d yyyy k:mm:ss z"
          )} to ${format(new Date(rest.endDate), "E MMM d yyyy k:mm:ss z")}`
        : "";

    const header =
      data?.warehouseActive?.Warehouse_Type !== "Storage"
        ? [
            "Bar Code",
            "Serial Number",
            "Item Name",
            "UnitCost",
            "Qty Issued",
            "Total",
            "Receiver",
            "Receiver Qty",
            "Date",
            "Status",
            "Comment",
          ]
        : [
            "Bar Code",
            "Serial Number",
            "Item Name",
            "UnitCost",
            "Qty Issued",
            "Total",
            "Receiver",
            "Comment",
            "Contract",
            "Returned",
            "Date",
            "Duration In Possession",
            "Status",
          ];

    exData = [
      [company],
      ["Job Item Issue Report"],
      [date],
      [""],
      header,
      ...exData,
      [""],
      ["", "", "", "", "Total", total],
    ];
    // console.log(exData);
    setExcelData(exData);
  };

  return (
    <Modal
      onHide={onHide}
      show={show}
      backdropClassName={`global-backdrop`}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      dialogClassName="requisition-details-modal preview-modal"
      animation={false}
      enforceFocus={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <div>
            <h1>Issued Item </h1>
          </div>
          {jobName ? (
            <p>
              {jobName} Issued items from {warehouseLocal?.namewh}
            </p>
          ) : null}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <main className="cash-book">
          <div className="content">
            <div className="content-main">
              <div className="content-body">
                <header className="text-nowrap">
                  <h1>
                    {!showFilter && (
                      <button
                        onClick={() => setShowFilter(!showFilter)}
                        className="btn filter"
                      >
                        <FilterTwoIcon />
                      </button>
                    )}
                    Issued Item History
                    <button
                      title="Refresh Issued Item History"
                      onClick={() => {
                        refetch();
                      }}
                      className="btn text-primary mx-3"
                    >
                      <CachedIcon />
                    </button>
                    <span className="fs-6">Select Customer : </span>
                    <div className="mx-3 w-100" style={{ zIndex: 999 }}>
                      {data?.warehouseActive?.Warehouse_Type !== "Storage" ? (
                        <Select
                          classNamePrefix={"form-select"}
                          menuPosition="fixed"
                          closeMenuOnSelect={true}
                          isLoading={isLoadingVendors}
                          isSearchable={true}
                          options={data?.requesters}
                          value={data?.requesters?.find(
                            (el) => filterParams?.Requester === el.value
                          )}
                          onChange={(selected) => {
                            setFilterParams({
                              ...filterParams,
                              Requester: selected?.value,
                            });
                          }}
                        />
                      ) : (
                        <Select
                          classNamePrefix={"form-select"}
                          menuPosition="fixed"
                          closeMenuOnSelect={true}
                          isLoading={isLoadingVendors}
                          isSearchable={true}
                          options={data?.locationsMap}
                          value={data?.locationsMap?.find(
                            (el) => filterParams?.Requester === el.value
                          )}
                          onChange={(selected) => {
                            setFilterParams({
                              ...filterParams,
                              Requester: selected?.value,
                            });
                          }}
                        />
                      )}
                    </div>
                    <span className="fs-6">Select Status : </span>
                    <div className="mx-3 w-100">
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        onChange={(e) => onStatusSelect(e.target.value)}
                        value={showStatus}
                      >
                        {allStatus.map((value, i) => (
                          <option value={value}>
                            {value === null ? "Pending" : value}
                          </option>
                        ))}
                      </select>
                    </div>
                  </h1>
                  <div className="actions mx-3">
                    <CSVLink
                      className="btn print d-none"
                      filename={`Job Item Issue Report(${format(
                        new Date(),
                        "dd-MMM-yyyy hh:mm:ss a"
                      )}).csv`}
                      data={excelData}
                      ref={CSVLinkRef}
                    />

                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        className="btn print"
                        disabled={isfetchingExcel}
                        bsPrefix=""
                      >
                        <ExportIcon color="#008000" />
                        Export
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        renderOnMount
                        className="text-center"
                      >
                        <Dropdown.Item
                          as="div"
                          onClick={onDownloadExcelData}
                          className="p-cursor"
                        >
                          Excel <ExcelIcon color="#008000" />
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </header>

                {data?.warehouseActive?.Warehouse_Type !== "Storage" ? (
                  <>
                    <div className="px-md-4">
                      <TableComponent
                        responsive
                        borderless
                        striped
                        tableHeadsFunction={tableHead}
                        mainDataArray={allIsuesItems}
                        tableDataRowFunction={displayTableData}
                        className="product-table text-nowrap"
                      />
                    </div>

                    {allIsuesItems?.length < 1 && (
                      <div className="d-flex justify-content-center">
                        <div className="info text-center">
                          <NoSelectedItemIcon />
                          <h2 className="my-2">No Item Available</h2>
                          <p />
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <div className="px-md-4">
                      <TableComponent
                        responsive
                        borderless
                        striped
                        tableHeadsFunction={tableStorageHead}
                        mainDataArray={allIsuesItems}
                        tableDataRowFunction={displayStorageTableData}
                        className="product-table text-nowrap"
                      />
                    </div>

                    {allIsuesItems?.length < 1 && (
                      <div className="d-flex justify-content-center">
                        <div className="info text-center">
                          <NoSelectedItemIcon />
                          <h2 className="my-2">No Item Available</h2>
                          <p />
                        </div>
                      </div>
                    )}
                  </>
                )}

                {allIsuesItems.length > 0 && (
                  <div className="d-flex justify-content-end my-4 mx-3">
                    <div className="gridChild gridChildBorderLeftBlue">
                      <div className="gridChildLeft">
                        <p className="gridChld1">
                          {currency(
                            allIsuesItems.reduce(
                              (a, b) => a + b.UnitCost * b.Quantity,
                              0
                            ),
                            {
                              symbol: "",
                            }
                          ).format()}
                        </p>
                        <p className="gridChld2">Total</p>
                      </div>
                    </div>
                  </div>
                )}

                <div className="d-flex justify-content-between px-3 align-items-center pagination">
                  <div className="pagination_left">
                    <p className="m-0 p-0">Show</p>
                    <select
                      value={queryParams.limit}
                      name="limit"
                      className="form-select "
                      onChange={(e) => handleSearchQueryChange(e)}
                    >
                      <option value="10">10 rows</option>
                      <option value="20">20 rows</option>
                      <option value="30">30 rows</option>
                      <option value="40">40 rows</option>
                      <option value="50">50 rows</option>
                      <option value="100">100 rows</option>
                    </select>
                  </div>

                  <ReactPaginate
                    {...paginationOptions}
                    pageCount={Math.ceil(
                      data.countItemsIssueLog / queryParams.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={0}
                    onPageChange={({ selected }) => {
                      document.body.scrollTop = document.documentElement.scrollTop = 0;
                      setQueryParams({
                        ...queryParams,
                        page: selected + 1,
                      });
                    }}
                    forcePage={parseInt(queryParams.page) - 1}
                  />
                </div>
              </div>
            </div>
          </div>
          <ModalLoader
            title="Please wait, processing request..."
            show={isLoading}
          />
        </main>
      </Modal.Body>
    </Modal>
  );
};

export default JobWareHouseIssuedItems;
